import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export function GuideCard({ guide }) {
  const to = `/guides/${guide.slug}`;
  return (
    <Link to={to} data-testid={`guide-card-${guide.slug}`}
      className="group block rounded-lg border border-slate-200 bg-white p-5 hover:border-navy hover:shadow-md transition-all">
      <div className="flex items-center gap-2 mb-2">
        <span className="label-caps text-slate-500">{guide.category}</span>
        {guide.featured && <span className="label-caps rounded bg-blue-100 px-1.5 py-0.5 text-royal">Cornerstone</span>}
      </div>
      <h3 className="font-heading font-bold text-lg text-navy leading-tight group-hover:underline">{guide.title}</h3>
      <p className="mt-1.5 text-sm text-slate-600 line-clamp-2">{guide.summary}</p>
      <span className="mt-3 inline-flex items-center gap-1 text-sm font-semibold text-royal">Read guidance <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" /></span>
    </Link>
  );
}
